export default __webpack_public_path__ + "static/media/1589.3ed70b27.png";